import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import LiveClock from "./LiveClock";
import { Menu, RefreshCw } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { toast } from "sonner";

const LOGO_URL = "https://customer-assets-lqy194kg.emergentagent.net/job_silapdi-dashboard/artifacts/u01hjm3v_ChatGPT%20Image%2026%20Agu%202026%2C%2011.23.20.webp";

const titles = {
  "/": "Dashboard Utama",
  "/status": "Status Pelaporan",
  "/a5": "Buku Matriks A.5",
  "/mutasi": "Mutasi Bulanan",
  "/rekap": "Rekapitulasi RT/RW",
  "/detail": "Detail RT",
  "/cetak": "Cetak A.5",
  "/rekap-bulanan": "Rekap Bulanan",
  "/rekap-tahunan": "Rekap Tahunan",
  "/ekspor": "Ekspor Data",
  "/master-aset": "Master TTD & Stempel",
  "/tentang": "Tentang Sistem",
};

export default function Layout() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const { logout } = useAuth();
  const title = titles[loc.pathname] || "SILAPDI";

  const handleLogout = async () => {
    try {
      await logout();
    } catch {
      toast.error("Gagal mengakhiri sesi. Periksa koneksi dan coba lagi.");
    }
  };

  return (
    <div className="main-wrap">
      <div className="hidden lg:block no-print sticky top-0 h-screen self-start">
        <Sidebar onLogout={handleLogout} />
      </div>

      {open && (
        <div className="lg:hidden no-print">
          <div className="drawer-backdrop" onClick={() => setOpen(false)} data-testid="drawer-backdrop" />
          <div className="drawer">
            <Sidebar onClose={() => setOpen(false)} onLogout={handleLogout} />
          </div>
        </div>
      )}

      <div className="content-area">
        {/* Brand banner with 3 logos + clock — always visible */}
        <div className="no-print brand-banner sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-[hsl(var(--border))]">
          <div className="brand-banner-inner">
            <button onClick={() => setOpen(true)} className="lg:hidden p-2 -ml-1 rounded-lg hover:bg-[hsl(var(--muted))]" data-testid="hamburger-btn">
              <Menu size={22} />
            </button>
            <img src={LOGO_URL} alt="SILAPDI · Kelurahan Suka Asih · Kota Bandung" className="brand-banner-logo" />
            <div className="flex-1 min-w-0 hidden sm:block">
              <div className="text-[0.68rem] font-bold tracking-widest text-[#0e6b4f] uppercase">SILAPDI</div>
              <div className="text-sm font-extrabold text-[#0e2b26] tracking-tight truncate">{title}</div>
              <div className="text-[0.68rem] text-[hsl(var(--muted-foreground))] truncate">Kelurahan Suka Asih · Kecamatan Bojongloa Kaler · Kota Bandung</div>
            </div>
            <LiveClock className="hidden md:flex flex-col items-end !gap-0" />
            <button
              onClick={() => window.location.reload()}
              className="p-2 rounded-lg text-[#0e2b26] hover:bg-[hsl(var(--muted))]"
              data-testid="refresh-btn"
              aria-label="Segarkan"
            >
              <RefreshCw size={17} />
            </button>
          </div>
          <div className="md:hidden px-4 pb-2">
            <LiveClock className="flex-row items-baseline" />
          </div>
        </div>

        <main className="p-4 sm:p-6 lg:p-8 fade-in">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
